import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {GetAnalyticsDashboard} from 'insights/analytics-dashboards/details/graphql/__generated/GetAnalyticsDashboard';
import {getAnalyticsQueryViewStateId} from 'insights/analytics-queries/AnalyticsQueryViewState';
import {runGraphQLAnalyticsQuery} from 'insights/analytics-queries/run-query/RunAnalyticsQueryActions';
import runWarehouseQueryGlobalState from 'insights/analytics-queries/run-query/runWarehouseQueryGlobalState';
import {getExtraDataToTrackRunQuery} from 'insights/analytics-queries/run-query/trackRunQuery';

type AnalyticsDashboard = ExtractByTypename<
  GetAnalyticsDashboard['analyticsDashboard'],
  'AnalyticsDashboardNode'
>;

export function refreshDashboard(
  analyticsDashboard: AnalyticsDashboard,
  analyticsDashboardViewStateId: string
): void {
  analyticsDashboard.analyticsQueries.forEach((analyticsQuery) => {
    const analyticsQueryViewStateId = getAnalyticsQueryViewStateId(
      analyticsQuery.id,
      analyticsDashboardViewStateId
    );

    runGraphQLAnalyticsQuery(
      analyticsQuery,
      analyticsQueryViewStateId,
      analyticsDashboard.parameterConfigs,
      analyticsDashboard.parameterValues,
      runWarehouseQueryGlobalState.getState(analyticsQueryViewStateId),
      getExtraDataToTrackRunQuery(analyticsDashboardViewStateId, true)
    );
  });
}
